import { Query, QueryTenantDashboardEmbedTokenArgs } from '@domain/graphql.types';
import { QueryTenantDashboardEmbedToken } from '@infrastructure/graphql';
import { useQuery } from 'urql';

type Props = {
  variables: QueryTenantDashboardEmbedTokenArgs;
  pause?: boolean;
};

const useTenantDashboardEmbedTokenQuery = ({ variables, pause }: Props) => {
  const [result, reexecuteQuery] = useQuery<Pick<Query, 'tenantDashboardEmbedToken'>, QueryTenantDashboardEmbedTokenArgs>({
    query: QueryTenantDashboardEmbedToken,
    variables,
    pause,
  });

  const { data, fetching, error } = result;

  return {
    data,
    fetching,
    error,
    reexecuteQuery,
  };
};

export default useTenantDashboardEmbedTokenQuery;
